import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import {IconMailComponent} from "./icon-mail";
import {IconLockDotsComponent} from "./icon-lock-dots";
import {IconUserComponent} from "./icon-user";
import {IconEditComponent} from "./icon-edit";
import {IconTrashLinesComponent} from "./icon-trash-lines";
import {IconTimesCirclet} from "./icon-times-circlet";
import {IconTimes} from "./icon-times";
import {AddOfferLinesComponent} from "./add-offer-lines";
import {IconEyeComponent} from "./icon-eye";

@NgModule({
    imports: [CommonModule],
    declarations: [
        IconMailComponent,
        IconLockDotsComponent,
        IconUserComponent,
        IconTrashLinesComponent,
        IconEditComponent,
        IconTimesCirclet,
        IconTimes,
        AddOfferLinesComponent,
        IconEyeComponent
    ],
    exports: [
        IconMailComponent,
        IconLockDotsComponent,
        IconUserComponent,
        IconTrashLinesComponent,
        IconEditComponent,
        IconTimesCirclet,
        IconTimes,
        AddOfferLinesComponent,
        IconEyeComponent
    ],
})
export class IconModule {}
